<template>
	<div>
		<el-card class="box-card" shadow="never" :body-style="{ padding: 0 }">
			<div slot="header" class="clearfix">
				<div class="messageInfo">
					<el-button class="btnCol" type="success" @click="dialogReadAllVisible=true">全部已读</el-button>
					<el-button class="btnCol" type="success" @click="selectMessageRead">设为已读</el-button>
					<el-button class="btnCol" type="danger" @click="isShowDelete">删除</el-button>
					<el-select v-model="noticeStatus" placeholder="选择消息类型" style="margin-left:20px;" @change="selectNoticeStatus">
						<el-option label="全部" :value="null"></el-option>
						<el-option label="已读" :value="1"></el-option>
						<el-option label="未读" :value="0"></el-option>
					</el-select>
				</div>
				<span class="notice">您有{{ totalNum }}条消息未读</span>
				<div class="titleFnWrap">
					<el-tabs v-model="activeName" @tab-click="handleClick" stretch>
						<el-tab-pane label="系统消息" name="first">

							<div class="list-box" v-for="item in tableList" :key="item.msgId">
								<ul>
									<li class="list-item">
										<input type="checkbox" :value="item.msgId" v-model="checkResult" @click="modifyCheck()">
										<div class="title"  @click="showContent(item)">
											<h3>{{ item.msgTitle }}</h3>
											<span class="createdTime">{{ item.createdTime }}</span>
										</div>
										<p class="des">{{ item.msgDesc }}</p>

										<span v-if="item.status == 0" class="circle"></span>
									</li>
								</ul>
			                </div>

							<div class="page-box">
								<el-pagination background layout="prev, pager, next" :current-page="pageObj.pageIndex"
									:total="pageObj.total" :page-size="pageObj.pageSize" @current-change="pageChange">
								</el-pagination>
							</div>
			            </el-tab-pane>
			            <el-tab-pane label="站内信" name="second"></el-tab-pane>
					</el-tabs>
				</div>
				
			</div>

			
		</el-card>

		<el-dialog :title="selectRow.msgTitle" width="50%" :visible.sync="rowVisible">
			<div ref="recruitContent" class="editor __remark" v-html="selectRow.msgContext"></div>
			<span slot="footer" class="dialog-footer">
        <el-button v-if="selectRow.msgTitle == '待提现通知'" @click="goTx()">去提现</el-button>
				<el-button v-else  @click="goWorkorder()">提交工单</el-button>
				<el-button type="primary" @click="rowVisible = false">确 定</el-button>
			</span>
		</el-dialog>

		<!--删除提示框-->
		<el-dialog
			title="提示"
			:visible.sync="dialogVisible"
			width="30%"
			>
			<span>确认删除这些消息?</span>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="selectMessageDelete">确 定</el-button>
			</span>
		</el-dialog>

		<!--删除提示框-->
		<el-dialog
			title="提示"
			:visible.sync="dialogReadAllVisible"
			width="30%"
			>
			<span>设为全部已读?</span>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogReadAllVisible = false">取 消</el-button>
				<el-button type="primary" @click="readAll">确 定</el-button>
			</span>
		</el-dialog>

	</div>
</template>

<script>
	import {
		noticeListApi,
		noticeNumApi,
		noticeUpdateApi,
		noticeUpdateRead,
		noticeUpdateUnread,
		noticeDelete,
		getStationMsg, // 站内信消息接口
	} from '@/api/notice';
	import {
		mapMutations
	} from "vuex";
	export default {
		data() {
			return {
				activeName: 'first',
				noticeStatus:null,
				dialogVisible: false,
				dialogReadAllVisible: false,
				pageObj: {
					pageSize: 15,
					pageIndex: 0,
					total: 0,
				},
				tableList: [],
				totalList: [],
				totalNum: 0,

				rowVisible: false,
				selectRow: {},
				checkResult:[],
				stationMsg: [], // 站内信数据
			};
		},
		created() {
			this.getTotal();
			this.getList();
		},
		methods: {
			/**
			 * 切换tabs
			 */
		    async handleClick(tab) {
              // 切换到站内信
			   if(tab.index == 1){
			   const res = await getStationMsg()
			   if(res.code == 200){
				this.stationMsg = res.data
				
			    }
			   
			   }
          },
			//选择消息类型
			selectNoticeStatus(){
				
				noticeListApi({
					status:this.noticeStatus
				}).then(res => {
					if (res.code === 200) {
						this.totalList = res.data;
						this.tableList = this.pageList(1);
					}
				});
			},

			// 全部已读
			readAll(){
				// console.log("点击了全部已读")
				this.dialogReadAllVisible = false
				noticeUpdateRead({}).then(res=>{
					if(res.code==200){
						this.tableList.forEach((item,index)=>{
							item.status = 1;
						})
						this.getTotal()
					}
				})
				

			},

			//选择消息设为已读
			selectMessageRead(){
				
				var arr = [];
				if(this.checkResult.length==0){
					this.$message.error("请选择要设为已读的消息");
					return false;
				}else{
					var list =  this.checkResult
					// console.log(msgId)
					noticeUpdateRead({
						list
					}).then(res=>{
						if(res.code = 200){
							for(var i = 0;i<this.checkResult.length;i++){
								arr[this.checkResult[i]]=true
							}
							for(var i=0;i<this.tableList.length;i++){
								if(arr[this.tableList[i].msgId]){
									this.tableList[i].status=1
								}
							}
							this.checkResult=[]
							this.getTotal()
						}
					})
				}
			},

			//消息设为未读
			selectMessageUnread(){
				
				var arr = [];
				if(this.checkResult.length==0){
					this.$message.error("请选择要设为未读的消息");
					return false;
				}else{
					var list =  this.checkResult
					// console.log(msgId)
					noticeUpdateUnread({
						list
					}).then(res=>{
						if(res.code = 200){
							for(var i = 0;i<this.checkResult.length;i++){
								arr[this.checkResult[i]]=true
							}
							for(var i=0;i<this.tableList.length;i++){
								if(arr[this.tableList[i].msgId]){
									this.tableList[i].status=0
								}
							}
							this.checkResult=[]
							this.getTotal()
						}
					})
				}
			},

			isShowDelete(){
				if(this.checkResult.length==0){
					this.$message.error("请选择要删除的消息");
					return false;
				}else{
					this.dialogVisible = true
				}
			},

			//删除选择消息
			selectMessageDelete(){
				
				var arr = [];
				var list =  this.checkResult
				
				noticeDelete({
					list
				}).then(res=>{
					if(res.code = 200){
						for(var i = 0;i<this.checkResult.length;i++){
							arr[this.checkResult[i]]=true
						}
						for(var i=0;i<this.tableList.length;i++){
							if(arr[this.tableList[i].msgId]){
								this.tableList.splice(i,1)
							}
						}
						this.checkResult=[]
						this.getTotal();
						this.dialogVisible = false;
					}
				})
			},



			//选择消息
			modifyCheck(){
				// console.log('点击了input')
				console.log(this.checkResult)
			},

			logRes(){
				console.log(this.checkResult)
			},

			...mapMutations({
				SET_BELL_BADGE: "SET_BELL_BADGE",
			}),
			pageChange(pageIndex) {
				this.tableList = this.pageList(pageIndex);
			},
			pageList(pageIndex) {
				const {
					pageSize
				} = this.pageObj;
				const realIndex = pageIndex - 1;
				const start = realIndex * pageSize;
				let arr = this.totalList.slice(start, pageIndex * pageSize);
				this.pageObj = Object.assign({}, this.pageObj, {
					pageIndex,
					total: this.totalList.length
				});

				return arr;
			},
			getList() {
				noticeListApi().then(res => {
					if (res.code === 200) {
						this.totalList = res.data;
						this.tableList = this.pageList(1);
					}
				});
			},
			getTotal() {
				noticeNumApi({
					status: 0
				}).then(res => {
					if (res.code === 200) {
						this.totalNum = res.data;
						this.SET_BELL_BADGE(this.totalNum ? this.totalNum : '');
					}
				})
			},

			showContent(item) {
				// 展示数据  可见性
				this.selectRow = item;
				this.rowVisible = true;
				/* 如果是未读 */
				if (item.status != 0) {
					return false;
				}

				let msgId = item.msgId;

				// 更新已读
				noticeUpdateApi({
					msgId
				}).then(res => {
					if (res.code == 200) {
						const index = this.tableList.findIndex(inner => {
							return inner.msgId == item.msgId
						});

						if (index > -1) {
							this.$set(this.tableList, index, {
								...this.tableList[index],
								status: 1
							});
						}

						this.totalNum = this.totalNum - 1 >= 0 ? this.totalNum - 1 : 0;
						this.SET_BELL_BADGE(this.totalNum ? this.totalNum : '');
					}
				});
			},

			// 提交工单
			goWorkorder() {
				this.$router.push('/user/workorder');
			},
      goTx(){
        this.$router.push('/user/tx');
      }
		}
	}
</script>

<style lang="less" scoped>
.messageInfo{
	margin-bottom: 10px;
   .btnCol{
	background-color: #073a39;
	border: none;
   }
}
	//新增样式
	.titleFnWrap{
	
		display: inline;
		span:first-child{
			margin-right: 30px;
			
		}
	}
	//新增样式结束


	.box-card {
		margin-bottom: 10px;
		border: none;
		position: relative;
		.notice{
		position: absolute;
		top: 30px;
		right: 200px;
	}
	}

	.list-box {
		.list-item {
			margin-bottom: 15px;
			position: relative;
			//background-color: rgba(9, 83, 46, 0.5);
			border-radius: 7px;
			padding: 10px 20px;
			cursor: pointer;
			border-bottom: 1px solid #eeeeee;
			display: flex;
			align-items: center;
			.title {
				display: flex;
				color: #1c6f6e;
				font-weight: 500;
				line-height: 30px;
				padding: 10px 0;

				span {
					padding-left: 10px;
					width: 150px;
					color: #fff;
					font-size: 14px;
				}
			}

			.des {
				line-height: 40px;
				font-size: 14px;
				color: #333333;
			}

			.circle {
				position: absolute;
				right: 10px;
				top: 10px;
				width: 10px;
				height: 10px;
				background: red;
				border-radius: 50%;
			}
		}
	}

	.page-box {
		padding: 30px 0;
		text-align: center;
	}
    /deep/.el-tabs__item.is-active {
		width: 80px;
		//background-color: #1c6f6e;
		background: linear-gradient(90deg, #044e48, #068a71);
		border-radius: 5px;
		color: #fff;
	}
	/deep/.el-tabs__nav-wrap::after {
		content: "";
		position: absolute;
		left: 0;
		bottom: 0;
		width: 100%;
		height: 0px;
		background-color: #E4E7ED;
		z-index: 1;
		}
	/*去掉切换时el-tab-pane底部的蓝色下划线*/
	/deep/.el-tabs__active-bar {
  background-color: transparent !important;
}
 
/*去掉tabs底部的下划线*/
/deep/.el-tabs__nav-wrap::after {
  position: static !important;
}
/deep/.el-tabs__item:hover {
color: #1da27c;
}
/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
        background-color: #1c6f6e;
        color: #FFF !important;
    }
    /deep/.el-pager li:hover {
        color: #1c6f6e !important;
    }
    
    input[type=checkbox] {
        cursor: pointer;
        position: relative;
        width: 18px;
        height: 18px;
        font-size: 12px;
    }
 
    input[type=checkbox]::after {
        position: absolute;
        top: 0;
        color: #000;
        width: 18px;
        height: 18px;
        display: inline-block;
        visibility: visible;
        padding-left: 0px;
        text-align: center;
        content: ' ';
        border-radius: 3px
    }
 
    input[type=checkbox]:checked::after {
        content: "✓";
        color: #1c6f6e;
        font-size: 16px;
        font-weight: bold;
        background-color: #fff;
    }
	
</style>
